import React from 'react'
import Slider from 'lib/ui/Slider'
import {Controller, UseFormMethods} from 'react-hook-form'
import ColorPicker from 'lib/ui/ColorPicker'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import {WidgetButton} from 'organization/Event/WidgetConfig/ButtonStylesConfig/WidgetButton'

export default function BorderSection(props: {
  control: UseFormMethods['control']
  button: WidgetButton
  storageKey: string
}) {
  const {control, button} = props

  return (
    <CollapsibleSection label="Border" storageKey={props.storageKey}>
      <Controller
        name="borderColor"
        control={control}
        defaultValue={button.borderColor || '#000000'}
        render={({value, onChange}) => (
          <ColorPicker label="Color" color={value} onPick={onChange} />
        )}
      />
      <Controller
        name="hoverBorderColor"
        control={control}
        defaultValue={button.hoverBorderColor || '#000000'}
        render={({value, onChange}) => (
          <ColorPicker label="Hover Color" color={value} onPick={onChange} />
        )}
      />
      <Controller
        name="borderWidth"
        defaultValue={button.borderWidth || 0}
        control={control}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Width"
          />
        )}
      />
      <Controller
        name="borderRadius"
        defaultValue={button.borderRadius || 0}
        control={control}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Radius"
          />
        )}
      />
    </CollapsibleSection>
  )
}
